import React from "react";
import {
  useShow,
  useGo,
} from "@refinedev/core";
import {
  Drawer,
} from "@mui/material";
import { IContact } from "@/utils/zod/contactFormValidation";
import { DrawerHeader } from "@/components";
import { ContactShowContent } from "@/components/contact/ContactShowContent";

export const ContactShow: React.FC = () => {
  const go = useGo();

  const { query } = useShow<IContact>({
    meta: {
      refetch: false
    }
  });
  const contact = query?.data?.data;

  const onDrawerClose = () => {
    go({
      to: {
        resource: "accounts",
        action: "list",
      },
      type: "replace",
    });
  };
  
  return (
    <Drawer
      open
      onClose={onDrawerClose}
      anchor="right"
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "736px",
        },
      }}
    >
      <DrawerHeader onCloseClick={onDrawerClose} />
      {contact && <ContactShowContent contact={contact} />}
    </Drawer>
  );
};

export default ContactShow; 